import { vellumApiSdk } from "@vellum/micro-app-auth";
import {
  getFriendlyDate,
  RecordTable,
  usePaginatedQuery,
  type Column,
} from "@vellum/ui";
import type { AdminCompanySchema } from "@vellum/vellum-api";
import { useState } from "react";

import { ListPage } from "@/components/ListPage";
import { ADMIN_PAGE_SIZE } from "@/lib/pagination";

const COLUMNS: Column<AdminCompanySchema>[] = [
  { header: "Name", render: (company) => company.name },
  {
    header: "Created",
    render: (company) => getFriendlyDate(company.created_at),
    className: "hidden sm:table-cell",
  },
  {
    header: "Last updated",
    render: (company) =>
      company.last_updated_at ? getFriendlyDate(company.last_updated_at) : "—",
    className: "hidden md:table-cell",
  },
];

export function CompaniesPage() {
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(0);
  const needle = query.trim();

  const { items, total, loading, isFetching, error } =
    usePaginatedQuery<AdminCompanySchema>(
      () =>
        vellumApiSdk.adminListCompanies({
          query: {
            limit: ADMIN_PAGE_SIZE,
            offset: page * ADMIN_PAGE_SIZE,
            q: needle || undefined,
          },
        }),
      "Something went wrong loading companies.",
      [page, needle],
    );

  return (
    <ListPage
      title="Companies"
      subtitle="Every company in Luna"
      query={query}
      onQueryChange={(value) => {
        setQuery(value);
        setPage(0);
      }}
      searchPlaceholder="Company name"
      loading={loading}
      isFetching={isFetching}
      error={error}
      page={page}
      pageSize={ADMIN_PAGE_SIZE}
      total={total}
      onPageChange={setPage}
    >
      <RecordTable
        columns={COLUMNS}
        rows={items}
        rowKey={(company) => company.id}
        emptyMessage={
          needle ? "No companies match that search." : "No companies yet."
        }
      />
    </ListPage>
  );
}
